module.exports = __webpack_public_path__ + "static/media/share_active.c863261b.svg";